import { Button } from "@/components/Button"
import { TablePagination } from "@/components/Pagination/TablePagination"
import { ITableHead, Table } from "@/components/Table"
import { DownloadIcon } from "@/components/two-factor/DownloadIcon"
import type { FC, ReactNode } from "react"
import React, { memo } from "react"
import { FormattedMessage } from "react-intl"

const TABLE_HEADS: ITableHead[] = [
  { key: "id" },
  { key: "name" },
  { key: "created" },
  { key: "amount" },
  { key: "card_pan" },
  { key: "status" },
  { key: "view" },
]

type Props = {
  pageSize: number
  data: Record<string, React.ReactNode>[]
  total: number
  page: number
  pageCount: number
  titleMessageId: string
  renderFilter: ReactNode
  onDownloadClick: () => void
  onPageChange: (page: number) => void
}

const ListBaseComponent: FC<Props> = ({ onDownloadClick, pageSize, data, page, pageCount, total, titleMessageId, renderFilter, onPageChange }) => {
  return (
    <>
      {renderFilter}

      <div className="table-orders mb-6">
        <div className="table-orders_header items-center">
          <div className="table-orders_title sm:!mb-0" style={{ marginBottom: 12 }}>
            <strong>
              <FormattedMessage id={titleMessageId} />
            </strong>
          </div>
          {data.length > 0 && onDownloadClick != null && (
            <Button variant="outlined" size="sm" onClick={onDownloadClick}>
              <DownloadIcon />
              <FormattedMessage id="download" />
            </Button>
          )}
        </div>
        <Table className="text-cl14 text-black" data={data} heads={TABLE_HEADS} classNames={{ row: "child:py-[22px]" }} />
      </div>
      {data.length > 0 && (
        <TablePagination perPage={pageSize} dataTotal={total} currentPage={page} totalPages={pageCount} onPageChange={onPageChange} />
      )}
    </>
  )
}

export const ListBase = memo(ListBaseComponent)
